import {
  Box,
  Button,
  Flex,
  HStack,
  Icon,
  Image,
  Text,
  VStack,
  Skeleton,
  SkeletonText,
  SkeletonCircle,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  CheckboxGroup,
  Checkbox,
  chakra,
  Spinner,
  useDisclosure,
  Avatar,
} from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import useModelSelecaoPacientes from './useModelSelecaoPacientes';
import useModelMedicos from '../Medicos/useModelMedicos';
import BackButton from '../../../../../../images/assets/telemedicina/backbutton.svg';
import Heart from '../../../../../../images/dashboard/visitante.png';
import Notificacao from '../../../../../../images/dashboard/notificacao.svg';
import Alert from '../../../../../../images/dashboard/alert.png';
import { StarIcon } from '@chakra-ui/icons';
import { IoIosAlert, IoMdCalendar } from 'react-icons/io';
import { useTelemedicina } from 'context/TelemedicinaContext';
import ModalAvisoEspecialidade from 'components/ModalAvisoEspecialidade';

function SelecaoPacientes() {
  const {
    error: errorMedico,
    loading: loadingMedico,
    especialista,
    modalEspecialista,
    setModalEspecialista,
    agendamento,
    atualizarAgendamento,
    medicos,
    avaliacoes_atualizadas,
    assinante,
    setMedicoSelecionado,
    user,
    toastInadimplente,
    proximasDatas,
    navigate: navigateMedico,
    loadingAgendas,
  } = useModelMedicos();
  const { titulo, navigate, modalPaciente, setModalPaciente, error, loading, dependentes, handleNavigate } = useModelSelecaoPacientes({
    assinante,
    titular: user.titular,
  });

  const [isLoading, setIsLoading] = useState(true);
  const [imgLoaded, setImgLoaded] = useState(false);
  const { paciente, setPaciente } = useTelemedicina();
  const [pacienteSelecionado, setPacienteSelecionado] = useState(null);
  const [opcaoSelecionada, setOpcaoSelecionada] = useState([]);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  const [modalAviso, setModalAviso] = useState(false);

  const [imgLoadedMedico, setImgLoadedMedico] = React.useState(false);
  const [localLoading, setLocalLoading] = React.useState(false);
  const modalAvisoAgendamento = useDisclosure();
  useEffect(() => {
    setLocalLoading(true);
    const timer = setTimeout(() => setLocalLoading(false), 900);
    return () => clearTimeout(timer);
  }, [agendamento?.especialidadeId]);

  const formatarEspecialidade = (txt) => txt?.toLowerCase()?.replace(/^\w/, (c) => c.toUpperCase());
  useEffect(() => {
    const dependentesValidos = Array.isArray(dependentes) ? dependentes.filter((d) => d && typeof d === 'object') : [];
    if (dependentesValidos.length && user && user?.username && !paciente) {
      const pacienteLogado = dependentesValidos.find((p) => p.cpf === user?.username);
      if (pacienteLogado) {
        setPaciente(pacienteLogado);
        setPacienteSelecionado(pacienteLogado.cpf);
      }
    }
  }, [dependentes, user, paciente, setPaciente]);

  const drawerEspecialista = () => {
    return (
      <Drawer isOpen={modalEspecialista} placement="bottom" onClose={() => setModalEspecialista(false)}>
        <DrawerOverlay />
        <DrawerContent borderTopRadius="20px" pb={4} w="100%" maxH="70vh" overflow="hidden" bg="white">
          <Box w="50px" h="6px" bg="#E0E0E0" borderRadius="full" mx="auto" mt={3} mb={2} />
          <DrawerBody p={0}>
            <VStack spacing={3} w="100%" maxH="65vh" overflowY="auto" px={4} pb={5}>
              {especialista?.map((item) => {
                const disponivel = item?.profissionais_disponiveis > 0;
                const selecionado = false;
                return (
                  <Flex
                    key={item?.id}
                    w="100%"
                    align="center"
                    justify="space-between"
                    p={3}
                    borderRadius="lg"
                    cursor="pointer"
                    bg={selecionado ? '#5AB2AE' : 'white'}
                    transition="0.15s"
                    _hover={{ bg: selecionado ? '#5AB2AE' : '#F4F7F7' }}
                    boxShadow="sm"
                    onClick={() => {
                      if (!disponivel) {
                        modalAvisoAgendamento.onOpen();
                        setOpcaoSelecionada({
                          especialidade_id: item?.ambulatorio_tipo_consulta_id,
                          paciente_id: paciente?.cpf,
                          username: user.nome,
                        });
                        return;
                      }

                      atualizarAgendamento({ especialidadeId: item?.ambulatorio_tipo_consulta_id });
                      setModalEspecialista(false);
                    }}
                  >
                    <HStack spacing={3}>
                      <Flex
                        bg={selecionado ? 'white' : '#E6F4F3'}
                        w="38px"
                        h="38px"
                        borderRadius="full"
                        align="center"
                        justify="center"
                        boxShadow="inner"
                      >
                        <Image src={Heart} w="18px" h="18px" />
                      </Flex>
                      <Text
                        fontWeight="600"
                        fontSize="md"
                        color={selecionado ? 'white' : '#4A4A4A'}
                        maxW="150px"
                        whiteSpace="normal"
                        wordBreak="break-word"
                      >
                        {capitalizeFirst(item?.descricao)}
                      </Text>
                    </HStack>
                    <Flex
                      bg={disponivel ? '#5AB2AE' : '#C96F1B'}
                      color={'white'}
                      px={3}
                      py={1.5}
                      borderRadius="full"
                      fontWeight="600"
                      minW="120px"
                      maxW="150px"
                      justify="center"
                      align="center"
                      textAlign="center"
                      fontSize="0.75em"
                      gap={2}
                      flexShrink={0}
                    >
                      {disponivel ? (
                        `${item?.profissionais_disponiveis} ${
                          item?.profissionais_disponiveis > 1 ? 'profissionais disponíveis' : 'profissional disponível'
                        } `
                      ) : (
                        <>
                          <Image src={Notificacao} boxSize="16px" objectFit="contain" />
                          Avisar disponibilidade
                        </>
                      )}
                    </Flex>
                  </Flex>
                );
              })}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  };

  const AvaliacaoEstrela = ({ avaliacao }) => {
    const [avaliacaoMedia, setAvaliacaoMedia] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const formatarAvaliacao = (media) => {
      const valor = Math.floor(media * 10) / 10;
      return valor.toFixed(1);
    };

    useEffect(() => {
      if (avaliacao) {
        const media =
          !avaliacao.avaliacao_media || avaliacao.avaliacao_media === '0' ? 5 : avaliacao.avaliacao_media >= 1 ? avaliacao.avaliacao_media : 5;
        setAvaliacaoMedia(formatarAvaliacao(media));
        setIsLoading(false);
      }
    }, [avaliacao]);
    return (
      <chakra.span mt={-0.5}>
        <StarIcon color="orange" fontSize="1em" mt={-0.3} />
        <chakra.span fontSize="0.625em" color="orange" fontWeight={600} ml={1}>
          {isLoading ? <Spinner size="sm" color="#5ab2ae" /> : avaliacaoMedia}
        </chakra.span>
      </chakra.span>
    );
  };

  const tratarNome = (nomeCompleto) => {
    if (!nomeCompleto) return '';

    const capitalizar = (palavra) => palavra.charAt(0).toUpperCase() + palavra.slice(1).toLowerCase();

    const partes = nomeCompleto.trim().split(/\s+/).filter(Boolean);

    if (partes.length === 0) return '';
    if (partes.length === 1) return capitalizar(partes[0]);

    const primeiroNome = capitalizar(partes[0]);
    const ultimoNome = capitalizar(partes[partes.length - 1]);

    return `${primeiroNome} ${ultimoNome}`;
  };

  let data_parcela = '';
  if (user?.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }
  const dataAtual = new Date();
  const clientePendente = user?.loggedIn && user?.qntdeParcelas?.countParcelas && user?.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela;

  useEffect(() => {
    if (clientePendente) {
      toastInadimplente(user.id_forma_pagamento, user.qntdeParcelas);
    }
  }, [assinante, clientePendente]);

  const drawerPaciente = () => {
    return (
      <Drawer isOpen={modalPaciente} placement="bottom" size="sm" onClose={() => setModalPaciente(false)}>
        <DrawerOverlay />
        <DrawerContent borderTopRadius={20} width="100%">
          <DrawerBody>
            <VStack mt="5%" spacing={4}>
              <CheckboxGroup value={[paciente?.cpf] || []}>
                <VStack align="start" w="100%" spacing={1}>
                  {(Array.isArray(dependentes) ? dependentes.filter((d) => d && typeof d === 'object') : []).map((pessoa) => {
                    return (
                      <Checkbox
                        key={pessoa?.cpf}
                        value={pessoa?.cpf}
                        isChecked={paciente?.cpf === pessoa?.cpf}
                        padding="1em"
                        onChange={() => {
                          setPaciente({
                            paciente_id: pessoa.paciente_id,
                            nome: pessoa.nome,
                            cpf: pessoa.cpf,
                            telefone: pessoa.telefone,
                            sexo: pessoa.sexo,
                            whatsapp: pessoa.whatsapp,
                            celular: pessoa.celular,
                            idade: pessoa.idade,
                          });
                          setPacienteSelecionado(pessoa.cpf);
                          setModalPaciente(false);
                        }}
                      >
                        <chakra.p fontWeight="bold" fontSize="sm">
                          {pessoa?.nome}
                        </chakra.p>
                      </Checkbox>
                    );
                  })}
                </VStack>
              </CheckboxGroup>
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    );
  };
  const capitalizeFirst = (text) => (text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : '');
  return (
    <>
      <ModalAvisoEspecialidade disclosure={modalAvisoAgendamento} dados={opcaoSelecionada} />
      <VStack bg="#5AB2AE" minH="100vh" w="100vw" spacing={0}>
        <Box
          bg="#5AB2AE"
          borderRadius="1em"
          p={3}
          w={{ base: '98%', sm: '96%' }}
          maxW="480px"
          position="fixed"
          top={2}
          left="50%"
          transform="translateX(-50%)"
          zIndex={10}
          mt={3}
        >
          <Flex align="center" justify="center" w="100%" position="relative">
            <Box position="absolute" left={0} top="50%" transform="translateY(-50%)">
              <SkeletonCircle isLoaded={imgLoaded} size={{ base: '14px', sm: '14px' }}>
                <Image
                  src={BackButton}
                  onClick={() => navigate(-1)}
                  cursor="pointer"
                  boxSize={{ base: '14px', sm: '14px' }}
                  onLoad={() => setImgLoaded(true)}
                />
              </SkeletonCircle>
            </Box>
            <Box flex={1} display="flex" justifyContent="center">
              <Skeleton isLoaded={!isLoading} borderRadius="8px">
                <Text fontSize={{ base: '1em', sm: '1.3em' }} color="white" fontWeight="bold" textAlign="center">
                  Telemedicina Especialista
                </Text>
              </Skeleton>
            </Box>
          </Flex>
        </Box>

        <Flex w="100vw" minH="100vh" align="center" justify="center" pt={{ base: 20, sm: 24 }}>
          <VStack
            bg="white"
            w={{ base: '98%', sm: '95%' }}
            maxW="500px"
            borderRadius="1em"
            spacing={5}
            p={{ base: 2, sm: 4 }}
            justify="space-between"
          >
            <VStack spacing={4} w="100%" p={4} alignItems="flex-start" mt={2}>
              <SkeletonText isLoaded={!isLoading} noOfLines={1} w="100%">
                <Text color="#616161" fontWeight="bold" mb={-3}>
                  Qual paciente será atendido?
                </Text>
              </SkeletonText>
              <Skeleton isLoaded={!isLoading} w="100%" h="3em" borderRadius="0.8em">
                <Text
                  name="pacientes"
                  borderRadius="0.8em"
                  textAlign="left"
                  fontWeight="normal"
                  backgroundColor="#EEEEEE"
                  h="3em"
                  w="100%"
                  display="flex"
                  alignItems="center"
                  pl={3}
                  cursor="pointer"
                  _focus={{ borderColor: '#5AB2AE' }}
                  onClick={() => setModalPaciente(true)}
                  disabled={loading}
                >
                  {paciente ? capitalizeFirst(paciente.nome) : loading ? 'Carregando pacientes...' : ''}
                </Text>
              </Skeleton>
            </VStack>

            <VStack spacing={4} w="100%" p={4} alignItems="flex-start">
              <SkeletonText isLoaded={!loadingMedico} noOfLines={1} w="100%">
                <Text color="#616161" fontWeight="bold" mb={-3}>
                  Encontre seu especialista!
                </Text>
              </SkeletonText>
              <Skeleton isLoaded={!loadingMedico} w="100%" h="3em" borderRadius="0.8em">
                <Text
                  name="especialistas"
                  borderRadius="0.8em"
                  textAlign="left"
                  fontWeight="normal"
                  backgroundColor="#EEEEEE"
                  h="3em"
                  w="100%"
                  display="flex"
                  alignItems="center"
                  pl={3}
                  cursor="pointer"
                  _focus={{ borderColor: '#5AB2AE' }}
                  onClick={() => setModalEspecialista(true)}
                  disabled={loadingMedico}
                >
                  {agendamento?.especialidadeId
                    ? especialista?.find((e) => e.ambulatorio_tipo_consulta_id === agendamento.especialidadeId)?.descricao
                    : loadingMedico
                      ? 'Carregando especialistas...'
                      : 'Filtrar Especialistas'}
                </Text>
              </Skeleton>
            </VStack>

            <Box
              w="100%"
              h="450px"
              maxH="450px"
              minH="450px"
              overflowY="auto"
              borderRadius="1em"
              boxShadow="sm"
              bg="#F9F9F9"
              transition="height 0.3s"
            >
              <VStack w="100%" spacing={4} h="100%" justify="flex-start">
                {loadingAgendas || localLoading || loadingMedico
                  ? Array.from({ length: 4 }).map((_, idx) => (
                      <Flex key={idx} align="center" bg="#F4F7F7" borderRadius="2em" p={3} mb={2} boxShadow="md" w="100%" opacity={0.7}>
                        <SkeletonCircle size="56px" mr={4} />
                        <Box flex="1">
                          <Skeleton height="20px" mb={2} borderRadius="md" />
                          <Skeleton height="16px" mb={1} borderRadius="md" />
                          <Skeleton height="16px" width="60px" borderRadius="md" />
                        </Box>
                        <Skeleton height="36px" width="90px" borderRadius="2em" />
                      </Flex>
                    ))
                  : (() => {
                      let listaMedicos = medicos && Array.isArray(medicos) ? medicos : [];
                      if (agendamento?.especialidadeId) {
                        listaMedicos = listaMedicos.filter(
                          (m) => String(m?.dados?.ambulatorio_tipo_consulta_id) === String(agendamento?.especialidadeId),
                        );
                      }
                      if (listaMedicos.length === 0 && !localLoading && !loadingMedico) {
                        return (
                          <Text color="#616161" fontSize="1em" fontWeight="bold" textAlign="center" mt={10} mb={10}>
                            Nenhum médico encontrado para a especialidade selecionada.
                          </Text>
                        );
                      }
                      return listaMedicos.map((medico, idx) => {
                        const avaliacao = avaliacoes_atualizadas.find((avaliacao) => avaliacao.operador_id === medico.dados.medico_id);
                        const proxima_data = medico.proximasDatas[0];
                        return (
                          <Flex key={idx} align="center" bg="#F4F7F7" borderRadius="2em" p={3} mb={2} boxShadow="md" w="100%" flexWrap="wrap">
                            <Avatar
                              src={
                                medico?.foto || medico?.dados?.foto
                                  ? medico?.foto || medico?.dados?.foto
                                  : process.env.REACT_APP_URL_PROFILEPICS_OPERADOR + '/' + medico.dados.medico + '/foto_profissional.png'
                              }
                              name={medico?.dados?.nome || medico?.nome || 'Médico'}
                              alt={medico?.dados?.nome || medico?.nome}
                              boxSize="56px"
                              borderRadius="full"
                              mr={4}
                              color="white"
                              onClick={() => navigate('/empresa/medico/curriculo', { state: { medico, avaliacao } })}
                              mt={2}
                              fontSize="0.75rem"
                              bg="#5AB2AE"
                            />

                            <Box flex="1" minW="180px" pr={2}>
                              <HStack w="100%" justify="space-between" align="center">
                                <Text fontWeight="bold" fontSize="md" color="#616161" maxW={{ base: '120px', sm: '200px', md: '200px' }} isTruncated>
                                  {medico.dados.sexo === 'F' ? 'Dra. ' : 'Dr. '}
                                  {(() => {
                                    const nome = tratarNome(medico?.dados?.nome || medico?.nome);
                                    return nome.length > 18 ? nome.slice(0, 18) + '…' : nome;
                                  })()}
                                </Text>
                                <AvaliacaoEstrela avaliacao={avaliacao} />
                              </HStack>
                              <Text fontSize="sm" color="#4A4A4A" noOfLines={2} maxW="180px" wordBreak="break-word">
                                {capitalizeFirst(medico?.dados?.especialidade || medico?.especialidade)}
                              </Text>
                              <Text fontSize="sm" color="#818181" noOfLines={2} maxW="180px" wordBreak="break-word">
                                {medico?.dados?.conselho && medico?.dados?.conselho} {medico?.dados?.conselho && medico?.dados?.rqe && ' '}{' '}
                                {medico?.dados?.rqe && medico?.dados?.rqe}
                              </Text>
                            </Box>
                            <Flex mt={4} w="100%" align="center" justify="space-between" flexDirection={{ base: 'column', sm: 'row' }} gap={3}>
                              {proxima_data ? (
                                <Text fontSize="md" color="#616161" fontWeight="bold" whiteSpace="nowrap" flexShrink={0}>
                                  {(() => {
                                    const procedimento = medico?.horarios?.[0]?.procedimentos?.[0];
                                    if (!procedimento) return null;

                                    const particular = procedimento?.procedimento_particular?.[0];
                                    const coparticipacao = procedimento?.procedimento_convenio?.[0];

                                    const valorConsulta = Number(procedimento?.valor ?? 0);
                                    const valorParticular = Number(particular?.particular_valor ?? 0);
                                    const valorCoparticipacao = Number(coparticipacao?.convenio_valor ?? 0);

                                    let valor = 0;
                                    let showAlert = false;

                                    const faltou = agendamento?.faltou;
                                    const especialidadeComDesconto = agendamento?.especialidades?.includes(
                                      String(medico?.dados?.ambulatorio_tipo_consulta_id),
                                    );

                                    if (faltou) {
                                      showAlert = assinante;

                                      if (assinante && user.id_plano === 70) {
                                        valor = valorCoparticipacao * 1.5;
                                      } else if (assinante) {
                                        valor = valorConsulta * 1.5;
                                      } else {
                                        valor = valorParticular;
                                      }
                                    } else {
                                      if (especialidadeComDesconto) {
                                        valor = 0;
                                      } else if (assinante && user.id_plano === 70) {
                                        valor = valorCoparticipacao;
                                      } else if (assinante) {
                                        valor = valorConsulta;
                                      } else {
                                        valor = valorParticular;
                                      }
                                    }

                                    return (
                                      <>
                                        {valor === 0
                                          ? 'R$ 0,00'
                                          : `${valor.toLocaleString('pt-BR', {
                                              style: 'currency',
                                              currency: 'BRL',
                                            })}`}
                                        {showAlert && (
                                          <Icon
                                            as={IoIosAlert}
                                            color="#D62422"
                                            ml={2}
                                            boxSize={6}
                                            cursor="pointer"
                                            onClick={() => setModalAviso(true)}
                                          />
                                        )}
                                      </>
                                    );
                                  })()}
                                </Text>
                              ) : (
                                <>
                                  <Spinner size="sm" color="teal.500" ml={2} />
                                </>
                              )}

                              <Button
                                fontWeight="normal"
                                colorScheme="teal"
                                borderRadius="2em"
                                px={6}
                                w={{ base: '100%', sm: 'auto' }}
                                minW="fit-content"
                                flexShrink={0}
                                fontSize="sm"
                                leftIcon={<Icon as={IoMdCalendar} boxSize={{ base: 5, sm: 5 }} flexShrink={0} />}
                                onClick={() => {
                                  atualizarAgendamento({
                                    medicoId: medico?.dados?.medico_id || medico?.medico_id,
                                  });
                                  setMedicoSelecionado({ medico: medico.dados, horarios: medico.horarios, avaliacao: avaliacao });
                                  navigateMedico('/horarios');
                                }}
                              >
                                Próxima data:{' '}
                                {!proxima_data ? (
                                  <Spinner size="sm" color="teal.500" ml={2} />
                                ) : proxima_data?.data ? (
                                  (() => {
                                    const d = new Date(proxima_data?.data);
                                    const dia = String(d.getDate()).padStart(2, '0');
                                    const mes = String(d.getMonth() + 1).padStart(2, '0');
                                    const ano = String(d.getFullYear()).slice(-2);
                                    return `${dia}/${mes}/${ano}`;
                                  })()
                                ) : (
                                  '---'
                                )}
                              </Button>
                            </Flex>
                          </Flex>
                        );
                      });
                    })()}
                {errorMedico && (
                  <Text color="red.500" fontSize="0.9em" textAlign="left" fontWeight={'bold'} lineHeight={1} w="90%">
                    {errorMedico}
                  </Text>
                )}
              </VStack>
            </Box>

            <VStack w="100%">
              {error && (
                <Text color="red.500" fontSize="0.9em" textAlign="left" fontWeight={'bold'} lineHeight={1} w="90%">
                  {error}
                </Text>
              )}
            </VStack>
            {modalEspecialista && drawerEspecialista()}
            {modalPaciente && drawerPaciente()}
            {modalAviso && (
              <Box
                position="fixed"
                top={0}
                left={0}
                w="100vw"
                h="100vh"
                bg="rgba(0,0,0,0.3)"
                zIndex={9999}
                display="flex"
                alignItems="center"
                justifyContent="center"
              >
                <Box bg="white" p={6} borderRadius="lg" boxShadow="lg" maxW="90vw" minW="280px" textAlign="center">
                  <Text fontWeight="bold" color="#D62422" mb={3} fontSize="lg">
                    Aviso
                  </Text>
                  <Text color="#333" fontSize="md" mb={4}>
                    O valor cobrado refere-se a uma multa de 50% do valor da consulta, aplicada por faltas em atendimentos anteriores no período de 60
                    dias.
                  </Text>
                  <Button colorScheme="red" onClick={() => setModalAviso(false)}>
                    Fechar
                  </Button>
                </Box>
              </Box>
            )}
          </VStack>
        </Flex>
      </VStack>
    </>
  );
}

export default SelecaoPacientes;
